import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import ClearIcon from '@mui/icons-material/Clear'
import VisibilityIcon from '@mui/icons-material/Visibility'
import EditIcon from '@mui/icons-material/Edit'
import { Grid, Typography, Divider, TablePagination } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { useTheme } from '@mui/material/styles'
import OutlinedInput from '@mui/material/OutlinedInput'
import {
  AddPlantToUser,
  FetchInternalUsersListNew,
  FetchPlantListNew,
  DeleteUserNew,
  FetchRoles,
  FetchOrganizations
} from '../../services/api'
import AddInternalUsers from '../Settings/components/AddInternalUsers/AddInternalUsers'
import Deleteplantimg from '../../assets/images/delete1.svg'
import Button from '@mui/material/Button'
import dayjs from 'dayjs'

import useInternalUserlistStyles from './styles'

import usePermission from '../../hooks/usePermission'

const InternalUserlist = ({ logic }) => {
  const classes = useInternalUserlistStyles()
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  }
  const { can } = usePermission()


  const thStyle = {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'center',
  }

  const tdStyle = {
    border: '1px solid #dddddd',
    padding: '8px',
    textAlign: 'center',
  }
  const theme = useTheme()
  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  function getStyles(name, plantIds, theme) {
    return {
      fontWeight:
        plantIds.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    }
  }

  const [open, setOpen] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [email, setEmail] = React.useState('')
  const [deleteuserEmail, setDeleteuserEmail] = React.useState('')
  const [plantList, setPlantList] = React.useState([])
  const [usersList, setUsersList] = React.useState([])
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(10)
  const [totalCount, setTotalCount] = useState(0)

  const [username, setUserName] = useState('')
  const [userId, setUserId] = useState('')
  const [deleteuserId, setDeleteUserId] = useState('')
  const [deleteUserName, setDeleteUserName] = useState('')
  const [openEdit, setOpenEdit] = useState(false)

  const [openView, setOpenView] = useState(false)
  const [selectedUserDetails, setSelectedUserDetails] = useState(null)
  const [isLoadingDetails, setIsLoadingDetails] = useState(false)

  const [rolesList, setRolesList] = useState([])
  const [orgList, setOrgList] = useState([])

  const [plantIds, setPlantIds] = React.useState([])
  const token = localStorage.getItem('accessToken')

  const fetchInternalUsers = (p, l) => {
    const targetPage = (p !== undefined ? p : page) + 1
    const targetLimit = l !== undefined ? l : limit

    FetchInternalUsersListNew(token, targetPage, targetLimit).then((resp) => {
      if (resp?.data) {
        const data = resp.data.data || resp.data
        const users = data.users || (Array.isArray(data) ? data : [])
        const total = data.pagination.total || data.count || (Array.isArray(data.users) ? data.users.length : 0)

        setUsersList(users)
        setTotalCount(total)
      }
    })
  }

  useEffect(() => {
    fetchInternalUsers(page, limit)

    FetchRoles(token).then(resp => {
      const roles = resp?.data?.roles || resp?.data?.data || []
      if (Array.isArray(roles)) setRolesList(roles)
    })

    FetchOrganizations(token).then(resp => {
      const orgs = resp?.data?.data || resp?.data?.organizations || []
      if (Array.isArray(orgs)) setOrgList(orgs)
    })

    const Order = '1'
    FetchPlantListNew(dayjs().format('YYYY-MM-DD'), token, Order).then(
      (resp) => {
        const plants = resp?.data?.data || resp?.data?.plants || []
        if (Array.isArray(plants)) setPlantList(plants)
      }
    )
  }, [openDelete, open, page, limit])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDeleteOpen = () => {
    setOpenDelete(true)
  }

  const handleDeleteClose = () => {
    setOpenDelete(false)
  }

  const handleOpenDeleteUser = (Data) => {
    setDeleteUserId(Data?.id || Data?._id || Data?.userId)
    setDeleteuserEmail(Data?.email)
    setDeleteUserName(Data?.name || `${Data?.firstName} ${Data?.lastName}`)
    handleDeleteOpen()
  }
  const handleDeleteUser = () => {
    DeleteUserNew(deleteuserId, token).then((resp) => {
      if (resp?.status === 200 || resp?.data) {
        setUsersList(prev => prev.filter(user => (user.id || user._id || user.userId) !== deleteuserId))
        handleDeleteClose()
      }
    })
  }

  const handleAddplant = (Data) => {
    setUserId(Data?.id)
    setEmail(Data?.email)
    handleOpen()
  }

  const handleAddUser = () => {
    const Data = {
      userId: userId,
      plantIds: plantIds,
    }

    AddPlantToUser(Data, token).then((resp) => {
      if (resp?.data) {
        handleClose()
      } else {
      }
    })
  }

  const handleChangePlantName = (event) => {
    const {
      target: { value },
    } = event
    setPlantIds(typeof value === 'string' ? value.split(',') : value)
  }

  const handleOpenView = (user) => {
    setSelectedUserDetails(user)
    setOpenView(true)
  }

  const handleEditUser = (user) => {
    if (logic) {
      logic.setters.setEditData(user)
      setOpenEdit(true)
    }
  }

  const handleEditClose = () => {
    setOpenEdit(false)
    if (logic) logic.setters.setEditData(null)
  }

  const getRoleName = (roleId) => {
    const role = rolesList.find(r => r.id === roleId || r._id === roleId)
    return role ? role.name : roleId
  }

  const getOrgName = (orgId) => {
    const org = orgList.find(o => o.id === orgId || o._id === orgId)
    return org ? org.organizationName : orgId
  }
  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {usersList?.map((Data) => (
                <tr key={Data.id || Data._id}>
                  <td style={tdStyle}>{Data?.name ?? Data?.firstName + " " + Data?.lastName}</td>
                  <td style={tdStyle}>{Data?.email}</td>
                  <td style={tdStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                      <VisibilityIcon
                        sx={{ cursor: 'pointer', color: '#1976d2' }}
                        onClick={() => handleOpenView(Data)}
                      />
                      <EditIcon
                        sx={{ cursor: 'pointer', color: '#2e7d32' }}
                        onClick={() => handleEditUser(Data)}
                      />
                      {can('settings.listOfUsers.delete') && (
                        <img
                          style={{
                            height: '20px',
                            width: '20px',
                            cursor: 'pointer',
                          }}
                          onClick={() => handleOpenDeleteUser(Data)}
                          src={Deleteplantimg}
                          alt="Delete user icon"
                        />
                      )}
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 2, alignItems: 'center' }}>
            <TablePagination
              component="div"
              count={Number(totalCount) || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              sx={{
                '& .MuiTablePagination-toolbar': {
                  padding: 0,
                  minHeight: '40px',
                },
                '& .MuiTablePagination-selectLabel': {
                  marginBottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-displayedRows': {
                  marginBottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-actions': {
                  marginLeft: 1,
                }
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Dialog
        className="businessview_dialog"
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">Add Plant To User</div>

            <DialogActions>
              <ClearIcon onClick={handleClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ width: '100%' }}>
                <FormControl sx={{ m: 1, width: 300 }}>
                  <InputLabel id="demo-multiple-name-label">
                    Choose Plant
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    value={plantIds}
                    onChange={handleChangePlantName}
                    input={<OutlinedInput label="Choose Plant" />}
                    MenuProps={MenuProps}
                  >
                    {plantList?.map((name) => (
                      <MenuItem
                        key={name?.id}
                        value={name?.id}
                        style={getStyles(name, plantIds, theme)}
                      >
                        {name?.plantDetails?.plantName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>{email}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <button onClick={handleAddUser} className="save_btn">
              Save
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        className="Delete_dialog"
        open={openDelete}
        onClose={handleDeleteClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Confirm Deletion</Typography>
            <ClearIcon onClick={handleDeleteClose} sx={{ cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to delete the user <strong>{deleteUserName}</strong>?
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="subtitle2" color="textSecondary">Email</Typography>
              <Typography variant="body2">{deleteuserEmail}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2" color="textSecondary">User ID</Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>{deleteuserId}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleDeleteClose} variant="outlined">Cancel</Button>
          <Button onClick={handleDeleteUser} variant="contained" color="error">
            Confirm Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Details Dialog */}
      <Dialog
        open={openView}
        onClose={() => setOpenView(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">User Details</Typography>
            <ClearIcon onClick={() => setOpenView(false)} sx={{ cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 3 }}>
          {selectedUserDetails && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Name</Typography>
                <Typography variant="body1">{selectedUserDetails?.name || `${selectedUserDetails?.firstName} ${selectedUserDetails?.lastName}`}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                <Typography variant="body1">{selectedUserDetails?.email}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Role</Typography>
                <Typography variant="body1">
                  {selectedUserDetails?.role?.name || (selectedUserDetails?.roles?.[0]?.name) || (selectedUserDetails?.metadata?.roleId ? getRoleName(selectedUserDetails.metadata.roleId) : 'N/A')}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Organization</Typography>
                <Typography variant="body1">
                  {selectedUserDetails?.organization?.name || (selectedUserDetails?.metadata?.organizationId ? getOrgName(selectedUserDetails.metadata.organizationId) : 'N/A')}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Department</Typography>
                <Typography variant="body1">{selectedUserDetails?.metadata?.department || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Hierarchy</Typography>
                <Typography variant="body1">{selectedUserDetails?.metadata?.hierarchy || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">Phone</Typography>
                <Typography variant="body1">{selectedUserDetails?.phone || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">Associated Plants</Typography>
                <Typography variant="body1">
                  {selectedUserDetails?.plants && selectedUserDetails.plants.length > 0
                    ? selectedUserDetails.plants.map(p => p.name).join(', ')
                    : 'None'}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenView(false)} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
      {/* Edit User Dialog */}
      <Dialog
        open={openEdit}
        onClose={handleEditClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Edit User</Typography>
            <ClearIcon onClick={handleEditClose} sx={{ cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 3 }}>
          <AddInternalUsers
            logic={logic}
            isModal={true}
            onClose={() => {
              handleEditClose();
              // Refresh list after edit
              FetchInternalUsersListNew(token).then((resp) => {
                if (resp?.data) {
                  setUsersList(resp?.data?.users || resp.data.data)
                }
              })
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default InternalUserlist
